import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { switchMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import { AuthService, WaitingListService } from '../../core/services';
import { materialModules } from '../../core/constants/mat-modules';

@Component({
    selector: 'madero-portal-redirect',
    templateUrl: './portal-redirect.component.html',
    styleUrl: './portal-redirect.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [...materialModules]
})
export class PortalRedirectComponent implements OnInit {
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #waitingListService = inject(WaitingListService);
  readonly #authService = inject(AuthService);
  readonly #snackBar = inject(MatSnackBar);

  readonly #code = this.#route.snapshot.paramMap.get('code')!;
  readonly codeError = signal(false);

  ngOnInit(): void {
    this.initializeRedirect();
  }

  initializeRedirect(): void {
    this.#waitingListService.getBranchAndEntryByFollowCode(this.#code).subscribe({
      next: ({ branchId, entryId }) =>
        this.#router.navigate(['portal', branchId], {
          queryParams: {
            entryId,
          },
        }),
      error: (err) => {
        this.codeError.set(true);
        console.log(err);
        this.#snackBar.open('Não foi possível redirecionar para a fila de espera!', 'Fechar', {
          verticalPosition: 'top',
          duration: 5000,
        });
      },
    });
  }
}
